module.exports = __webpack_public_path__ + "static/media/login3.67df6c04.jpg";